import { endOfDay, startOfDay, startOfMonth, startOfWeek } from "date-fns";

import { ReportsDashboard } from "@/features/dashboard/reports-dashboard";

export const Route = createFileRoute({
  component: () => {
    const now = new Date();

    return (
      <ReportsDashboard
        startOfDay={startOfDay(now)}
        endOfDay={endOfDay(now)}
        startOfMonth={startOfMonth(now)}
        startOfWeek={startOfWeek(now)}
      />
    );
  },
});
